<template>
	<!-- eslint-disable -->

	<header class="header">

		<div class="header__container">

			<a :href="highestLevel | cr" class="back-btn">
				<i class="fa-solid fa-arrow-left"></i>
			</a>

			<router-link to="/" class="header__logo">
				<img
					:src="'reyrock-rebrand/Reyrock_Wordmark_Black_Transparent_2048px.png' | assetsImg"
					aria-label="Reyrock"
					alt="Reyrock"
				>
			</router-link>

			<nav class="header__menu">

				<router-link
					v-for="(item, key) in navigation"
					:key="key"
					:to="item.href | cr"
				>
					{{ item.label | i18n }}
				</router-link>

				<a href="#contact" class="header__contact">
					{{ 'Connect With Us' | i18n }}
				</a>

				<div class="header__language">

					<button type="button" class="language__btn">
						<i class="fa-solid fa-earth-americas"></i>
					</button>

					<ul class="language__menu">

						<li v-for="lang in langs" :key="lang.key">
							<a
								href="#"
								:data-lang="lang.key"
								@click.prevent="setLang(lang.key)"
							>
								{{ lang.label | i18n }}
							</a>
						</li>

					</ul>

				</div>

			</nav>

			<button
				type="button"
				class="menu-toggle"
				:class="{ 'active': isMenuOpen }"
				@click="toggleMenu"
			>
				<i class="fa-solid fa-bars"></i>
			</button>

		</div>

		<div
			class="mobile-overlay"
			:class="{ 'active': isMenuOpen }"
			@click="toggleMenu"
		></div>

		<aside
			class="mobile-menu"
			:class="{ 'active': isMenuOpen }"
		>

			<button
				type="button"
				class="mobile-menu__close"
				@click="toggleMenu"
			>
				<i class="fa-solid fa-xmark"></i>
			</button>

			<router-link to="/" class="mobile-menu__logo">
				<img
					:src="'reyrock-rebrand/Reyrock_Wordmark_FullColor_Transparent_1024px.png' | assetsImg"
					aria-label="Reyrock"
					alt="Reyrock"
				>
			</router-link>

			<nav class="mobile-menu__nav">

				<router-link
					v-for="(item, key) in navigation"
					:key="key"
					:to="item.href | cr"
				>
					{{ item.label | i18n }}
				</router-link>

				<a href="#contact" class="mobile-menu__contact">
					{{ 'Connect With Us' | i18n }}
				</a>

			</nav>

			<div class="mobile-language">

				<a
					href="#"
					v-for="lang in langs"
					:key="lang.key"
					:data-lang="lang.key"
					@click.prevent="setLang(lang.key)"
				>
					{{ lang.label | i18n }}
				</a>

			</div>

		</aside>

	</header>
</template>

<script>
/* eslint-disable */
import { langUserSet, langUserGet } from '@/utils.js';

export default {
	name: "navHeaderAlt",

	props: {
		highestLevel: {
			type: String,
			default: 'site_br_root'
		},

		navigation: {
			type: Object,
			default: () => ({
				properties: {
					key: "properties",
					label: "Properties",
					href: "/properties"
				},
				ventures: {
					key: "ventures",
					label: "Ventures",
					href: "/ventures"
				},
				talent: {
					key: "talent",
					label: "Talent",
					href: "/talent"
				}
			})
		},

		langs: {
			type: Array,
			default: () => [
				{ key: "en", label: "English" },
				{ key: "fr", label: "Français" },
				{ key: "es", label: "Español" }
			]
		}
	},

	computed: {
		langUserGet
	},

	data: () => {
		return {
			isMenuOpen: false
		};
	},

	methods: {
		setLang(lang) {
			langUserSet(lang);
			document.location.reload();
		},

		toggleMenu() {
			this.isMenuOpen = !this.isMenuOpen;

			if (this.isMenuOpen) {
				document.body.style.overflow = "hidden";
			} else {
				document.body.style.overflow = "";
			}
		}
	},

	mounted() {
		setTimeout(() => {
			const navbar = document.querySelector('.header');

			if (window.scrollY >= 10) {
				navbar.classList.add('scrolled');
			}
		}, 100);
	}
};
</script>

<style lang="scss" scoped>
.header {

	&__container {
		display: flex;
		align-items: center;
		flex-wrap: nowrap;
		gap: 20px;
	}

	&__logo {
		flex-shrink: 0;
	}

	&__menu {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: clamp(22px, 2.5vw, 48px);
		margin-left: auto;
		min-width: 0;

		> a {
			white-space: nowrap;
		}
	}

	&__contact {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		min-height: 40px;
		padding: 0 16px;
		border: 1px solid #B45D2D;
		border-radius: 4px;
		color: inherit;
		font-size: 13px;
		font-weight: 600;
		letter-spacing: .4px;
		text-transform: uppercase;
		transition: .3s;
		flex-shrink: 0;

		&:hover {
			background: #B45D2D;
			color: #FFF;
		}
	}

	&__language {
		flex-shrink: 0;

		a:hover {
			color: #FFF !important;
		}
	}

	.menu-toggle {
		display: none;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
	}

	.mobile-menu {
		padding-bottom: 120px;
		background: #0D141D;
	}

	.mobile-menu__logo img {
		width: 220px;
		position: relative;
		top: 1.1px;
		right: 18.9px;
	}

	.mobile-menu__contact {
		color: #B45D2D;
		font-weight: 600;
	}

	&.scrolled {
		background-color: hsla(36, 33%, 94%, 0.95);
		backdrop-filter: blur(12px) invert(1) saturate(0.2);
	}

	@media (max-width: 1350px) {

		&__container {
			gap: 14px;
		}

		&__menu {
			gap: 22px;

			> a {
				font-size: 14px;
			}
		}

		&__contact {
			min-height: 38px;
			padding: 0 12px;
			font-size: 11px;
		}
	}

	@media (max-width: 1280px) {

		&__menu {
			display: none;
		}

		.menu-toggle {
			display: flex !important;
			margin-left: auto;
		}
	}

	@media (min-width: 1281px) {

		.menu-toggle {
			display: none !important;
		}
	}
}
</style>